<template>
  <MapMarker>
    <v-icon v-html="outtrip.sport.materialIcon"></v-icon>
  </MapMarker>
</template>

<script>
import MapMarker from "@/components/MapMarker";
export default {
  components: {MapMarker},
  props: {
    outtrip: {
      required: true
    }
  }
}
</script>
